<template>
    <LayoutBase>
        <div class="full-height grid">
            <account-sidebar></account-sidebar>

            <div id="content-wrapper" class="app-position">
                <div class="container-fluid">
                    <div class="row no-gutters">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <div class="article-wrapper">
                                <div class="panel">
                                    <header>
                                        <h1>Manage Team</h1>
                                        <router-link :to="{ name: 'settings-users-invite' }">Invite Team Members</router-link>
                                    </header>

                                    <table class="table">
                                        <thead>
                                            <th colspan="2">Name</th>
                                            <th></th>
                                            <th></th>
                                        </thead>

                                        <tbody>
                                            <tr v-for="user in users">
                                                <td>
                                                    <avatar :user="user" :key="user.id"></avatar>
                                                </td>
                                                <td>
                                                    <router-link :to="{ name: 'view-profile', params: { user: user.id } }">{{ user.name }}</router-link><br>
                                                    {{ user.email }}
                                                </td>
                                                <td width="200px">
                                                    <button class="btn btn-small" v-on:click.stop.prevent="openModal('make-admin-' + user.id)" v-if="user.pivot.admin == 0">Make admin</button>

                                                    <button class="btn btn-small" v-on:click.stop.prevent="openModal('remove-admin-' + user.id)" v-if="user.pivot.admin == 1">Remove admin</button>

                                                    <button class="btn btn-small btn-danger" v-on:click.stop.prevent="openModal('delete-user-' + user.id)">Delete</button>

                                                    <div class="modal micromodal-slide" :id="'make-admin-' + user.id" aria-hidden="true">
                                                        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                                                            <div class="modal__container" role="dialog" aria-modal="true">
                                                                <div class="modal__content">
                                                                    <h3>Make {{ user.name }} an admin</h3>
                                                                    <p>Are you sure you wish to make {{ user.name }} an admin?</p>
                                                                </div>
                                                                <footer class="modal__footer">
                                                                    <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                                                                    <button class="btn btn-primary" v-on:click.stop.prevent="makeAdmin(user.id)">Make an admin</button>
                                                                </footer>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="modal micromodal-slide" :id="'remove-admin-' + user.id" aria-hidden="true">
                                                        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                                                            <div class="modal__container" role="dialog" aria-modal="true">
                                                                <div class="modal__content">
                                                                    <h3>Remove admin permissions for {{ user.name }}</h3>
                                                                    <p>Are you sure you wish to remove admin permissions for {{ user.name }}?</p>
                                                                </div>
                                                                <footer class="modal__footer">
                                                                    <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                                                                    <button class="btn btn-primary" v-on:click.stop.prevent="removeAdmin(user.id)">Remove</button>
                                                                </footer>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="modal micromodal-slide" :id="'delete-user-' + user.id" aria-hidden="true">
                                                        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                                                            <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-new-category-title">
                                                                <div class="modal__content" id="modal-new-category-content">
                                                                    <h3>Delete {{ user.name }}</h3>
                                                                    <p>Are you sure you wish to delete {{ user.name }}?</p>
                                                                </div>
                                                                <footer class="modal__footer">
                                                                    <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                                                                    <button class="btn btn-danger" v-on:click.stop.prevent="deleteUser(user.id)">Delete</button>
                                                                </footer>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import MicroModal from 'micromodal';
    import LayoutBase from '../../layouts/LayoutBase';
    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                users: [],
            }
        },
        mounted() {
            this.getUsers();
        },
        methods: {
            openModal(modal){
                MicroModal.show(modal);
            },
            getUsers() {
                axios.get('/api/account/users').then((response) => {
                    this.users = response.data;
                }, (response) => {
                    this.error = response;
                });
            },
            makeAdmin(user_id) {
                axios.put('/api/user/' + user_id + '/make-admin').then((response) => {
                    this.getUsers();
                    MicroModal.close("make-admin-" + user_id);
                }, (response) => {
                    this.error = response;
                });
            },
            removeAdmin(user_id) {
                axios.put('/api/user/' + user_id + '/remove-admin').then((response) => {
                    this.getUsers();
                    MicroModal.close("remove-admin-" + user_id);
                }, (response) => {
                    this.error = response;
                });
            },
            deleteUser(user_id) {
                axios.delete('/api/user/' + user_id).then((response) => {
                    this.users = response.data;
                }, (response) => {
                    this.error = response;
                });
            },
        },
        // Guard to protect route from none admins
        beforeRouteEnter(to, from, next){
            if (!window.user_can.admin) next('/')
            else next()
        }
    }
</script>

<style lang="scss">

</style>